import { CSSProperties } from 'react';

export const flexVertical: CSSProperties = {
    display: "flex", flexDirection: "column"
}

export const flexHorizontal: CSSProperties = {
    display: "flex", flexDirection: "row"
}